import { api, getBlob } from "../../services/NetworkBase";

export async function GetClients(page = 1, pageSize = 10, searchText = "") {
	try {
		let response = await api
			.get(`vlp/clients-maintenance?page=${page}&pageSize=${pageSize}&searchText=${encodeURIComponent(searchText)}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function GetClientByAccount(accountNumber) {
	try {
		let response = await api
			.get(`vlp/clients-maintenance/account-number/${accountNumber}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function ChangeClientStatusByAccount(accountNumber) {
	try {
		let response = await api
			.get(`vlp/clients-maintenance/change-status/account-number/${accountNumber}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function UpdateClient(client) {
	try {
	  let response = await api.put(
		"vlp/clients-maintenance",
		{ json: client }
	  );
	  return response;
	} catch (error) {
	  throw error;
	}
  }

  export async function BatchUpdateClientInfo(client) {
	try {
	  let response = await api.put(
		"vlp/clients-maintenance/batch-update",
		{ json: client }
	  );
	  return response;
	} catch (error) {
	  throw error;
	}
  }

  export async function SaveNewClient(client) {
	try {
	  let response = await api.post(
		"vlp/clients-maintenance",
		{ json: client }
	  );
	  return response;
	} catch (error) {
	  throw error;
	}
  }


export async function GetMultiSelectClients(clientType="", forceRefresh = false) {
	try {
		let response = await api
			.get(`vlp/clients-maintenance/multi-select?clientType=${clientType}&forceRefresh=${forceRefresh}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function GetAllClients() {
	try {
		let response = await api
			.get(`vlp/clients-maintenance/all`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}
export async function DeleteClient(id) {
	try {
	  let response = await api
		.delete(`vlp/clients-maintenance/`+id)
		.json();
	  return response;
	} catch (error) {
	  throw error;
	}
}

export async function GetSampleLocations(accountNumber) {
	try {
		let response = await api
			.get(`vlp/clients-maintenance/account-number/${accountNumber}/sample-locations`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function GetCustCharges(accountNumber) {
	try { return await api.get(`vlp/clients-maintenance/account-number/${accountNumber}/cust-charges`).json(); }
	catch (error) { throw error; }
}
export async function SaveCustCharge(dto) {
	try { return await api.post(`vlp/clients-maintenance/cust-charges`, { json: dto }).json(); }
	catch (error) { throw error; }
}
export async function UpdateCustCharge(dto) {
	try { return await api.put(`vlp/clients-maintenance/cust-charges`, { json: dto }).json(); }
	catch (error) { throw error; }
}
export async function DeleteCustCharge(recordid) {
	try { return await api.delete(`vlp/clients-maintenance/cust-charges/${recordid}`).json(); }
	catch (error) { throw error; }
}

export async function GetOperatorAccounts(accountNumber) {
	try { return await api.get(`vlp/clients-maintenance/account-number/${accountNumber}/operator-accounts`).json(); }
	catch (error) { throw error; }
}
export async function AddOperatorAccount(dto) {
	try { return await api.post(`vlp/clients-maintenance/operator-accounts`, { json: dto }).json(); }
	catch (error) { throw error; }
}
export async function RemoveOperatorAccount(recordid) {
	try { return await api.delete(`vlp/clients-maintenance/operator-accounts/${recordid}`).json(); }
	catch (error) { throw error; }
}

export async function GetFacilityIds(accountNumber) {
	try { return await api.get(`vlp/clients-maintenance/account-number/${accountNumber}/facility-ids`).json(); }
	catch (error) { throw error; }
}
export async function SaveFacilityId(dto) {
	try { return await api.post(`vlp/clients-maintenance/facility-ids`, { json: dto }).json(); }
	catch (error) { throw error; }
}
export async function DeleteFacilityId(id) {
	try { return await api.delete(`vlp/clients-maintenance/facility-ids/${id}`).json(); }
	catch (error) { throw error; }
}

export async function GetSamplingPointIds(accountNumber) {
	try { return await api.get(`vlp/clients-maintenance/account-number/${accountNumber}/sampling-point-ids`).json(); }
	catch (error) { throw error; }
}
export async function SaveSamplingPointId(dto) {
	try { return await api.post(`vlp/clients-maintenance/sampling-point-ids`, { json: dto }).json(); }
	catch (error) { throw error; }
}
export async function DeleteSamplingPointId(id) {
	try { return await api.delete(`vlp/clients-maintenance/sampling-point-ids/${id}`).json(); }
	catch (error) { throw error; }
}

export async function GetOrderTemplates(accountNumber) {
	try { return await api.get(`vlp/clients-maintenance/account-number/${accountNumber}/order-templates`).json(); }
	catch (error) { throw error; }
}
export async function SaveOrderTemplate(dto) {
	try { return await api.post(`vlp/clients-maintenance/order-templates`, { json: dto }).json(); }
	catch (error) { throw error; }
}
export async function UpdateOrderTemplate(dto) {
	try { return await api.put(`vlp/clients-maintenance/order-templates`, { json: dto }).json(); }
	catch (error) { throw error; }
}
export async function DeleteOrderTemplate(recordid) {
	try { return await api.delete(`vlp/clients-maintenance/order-templates/${recordid}`).json(); }
	catch (error) { throw error; }
}




// Attachments (ENB-602)
export async function GetClientAttachments(accountNumber) {
	try { return await api.get(`vlp/clients-maintenance/account-number/${encodeURIComponent(accountNumber)}/attachments`).json(); }
	catch (error) { throw error; }
}
export async function UploadClientAttachment(accountNumber, formData) {
	try { return await api.post(`vlp/clients-maintenance/account-number/${encodeURIComponent(accountNumber)}/attachments`, { body: formData }).json(); }
	catch (error) { throw error; }
}
export async function DeleteClientAttachment(accountNumber, id) {
	try { return await api.delete(`vlp/clients-maintenance/account-number/${encodeURIComponent(accountNumber)}/attachments/${id}`).json(); }
	catch (error) { throw error; }
}
// Same (fileName, owner) argument order as GetOrderDocument so DocumentViewer can take it.
export async function GetClientAttachmentDocument(fileName, accountNumber) {
	return getBlob(`vlp/clients-maintenance/account-number/${encodeURIComponent(accountNumber)}/attachments/document?fileName=${encodeURIComponent(fileName)}`);
}
